import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const TermsConditionsPage = () => {
    return (
        <div className="container max-w-4xl mx-auto py-8 px-4" data-testid="terms-conditions-page">
            {/* Back button */}
            <div className="mb-6">
                <Link to="/apply">
                    <Button variant="ghost" className="gap-2">
                        <ArrowLeft className="h-4 w-4" />
                        Back to Membership Application
                    </Button>
                </Link>
            </div>

            <Card>
                <CardHeader className="text-center border-b">
                    <CardTitle className="text-2xl">Terms & Conditions</CardTitle>
                    <p className="text-lg text-muted-foreground mt-2">HAAPE's Workforce Ecosystem Member Partnership</p>
                </CardHeader>
                <CardContent className="prose prose-slate max-w-none py-8">
                    {/* Mission Statement */}
                    <div className="bg-primary/5 border-l-4 border-primary p-4 mb-8">
                        <p className="font-semibold text-primary mb-0">
                            HAAPE'S MISSION: TO CREATE AUTISM WORKFORCE ECOSYSTEMS FOCUSED ON TRAINING AND EDUCATION THAT EMPOWER AUTISTIC INDIVIDUALS TO OBTAIN MEANINGFUL AND SUSTAINABLE CAREERS AND CONNECTING STAKEHOLDERS TO PROVIDE EMPLOYMENT OPPORTUNITIES FOR THESE INDIVIDUALS.
                        </p>
                    </div>

                    {/* Introduction */}
                    <p className="text-muted-foreground">
                        This agreement is made and entered into by and between the applying organization ("HWE Member") and Helping Adults with Autism Perform and Excel (HAAPE), a 501(c)(3) non-profit organization with an EIN # of 81-1709197. By entering into this agreement, HWE Member and HAAPE agree as follows:
                    </p>

                    {/* Section 1 */}
                    <h3 className="text-lg font-semibold mt-8 mb-3">1. Term</h3>
                    <p>
                        This agreement begins on the date of acceptance and continues until either party wishes to terminate with a minimum of thirty (30) days' advance written notice. HAAPE shall conduct an annual review to determine effectiveness of the membership between HWE Member and HAAPE ("MEMBERSHIP"). At this time there are no fees associated with member access to the HAAPE Hub. We reserve the right to implement a fee structure with 30 days' written notice.
                    </p>

                    {/* Section 2 */}
                    <h3 className="text-lg font-semibold mt-8 mb-3">2. Membership Objective</h3>
                    <p>
                        HWE Member agrees to participate in and assist the HWE by networking with other organizations ("Referrals") in their local geography with the common goal of finding meaningful and sustainable employment for the autistic community. At such time as the Referrals are approved by HAAPE, such Referrals shall enter into an agreement with HAAPE in same format to these Terms. HAAPE has the right to modify these Terms at any time so long as the HWE Member and HAAPE agree to the modified terms in writing.
                    </p>

                    {/* Section 3 */}
                    <h3 className="text-lg font-semibold mt-8 mb-3">3. Primary Responsibilities</h3>
                    
                    <h4 className="font-semibold mt-4 mb-2">HAAPE agrees to:</h4>
                    <ul className="list-disc pl-6 space-y-2">
                        <li>Assist HWE Member in establishing a local/national geographic ecosystem</li>
                        <li>Assist and approve Referrals</li>
                        <li>Connect/introduce other HWE Members to allow for sharing best practices within the HWE</li>
                        <li>Vet all Referrals to ensure mission alignment</li>
                        <li>Develop and maintain an HWE database referred to as the HAAPE HUB</li>
                        <li>Share Referral information with others in the HWE (depending on the terms of each HWE Membership's respective agreement)</li>
                        <li>Provide guidance for HWE Members and Referrals to identify employers</li>
                        <li>Share resources through the database</li>
                        <li>Support the local HWE and its referrals on HAAPE's social media and website (as appropriate)</li>
                        <li>Assist HWE Members in securing grant and sponsorship funding by providing support letters as appropriate</li>
                        <li>Allow HWE Members to offer educational seminars on mutually agreed topics when applicable</li>
                    </ul>

                    <h4 className="font-semibold mt-6 mb-2">HWE Member agrees to:</h4>
                    <ul className="list-disc pl-6 space-y-2">
                        <li>Assist HAAPE in establishing a local/national geographic ecosystem</li>
                        <li>Share organization and contact information by entering into the HAAPE Hub</li>
                        <li>Input key performance data in the HAAPE Hub at least annually (e.g. graduation, hiring, and retention numbers)</li>
                        <li>Actively network with HWE Members and Referrals and participate in HAAPE's Community of Interest as requested</li>
                        <li>Promote HAAPE and the HWE Members and Referrals on social media and website (as appropriate)</li>
                        <li>Share employment best practices with HAAPE and the HWE Members and Referrals</li>
                        <li>Assist HAAPE to secure grant and sponsorship funding by providing support letters as needed</li>
                        <li>Provide graduation and employment success stories and testimonials</li>
                    </ul>

                    {/* Section 4 */}
                    <h3 className="text-lg font-semibold mt-8 mb-3">4. Confidentiality</h3>
                    <p>
                        HWE Member and HAAPE shall only share contact information and performance data housed within the HAAPE Hub with other approved referrals of the HWE. HAAPE shall only publish performance data that has been entered by referrals on a consolidated basis. HAAPE may publish testimonials and photos that have been entered into the Hub.
                    </p>

                    {/* Section 5 */}
                    <h3 className="text-lg font-semibold mt-8 mb-3">5. Compliance With Applicable Laws</h3>
                    <p>
                        Both parties shall comply with all laws, ordinances, rules, and regulations of any government or administrative agency, federal, state or local in performing any and all services related to these Terms. If the Partnership requires sharing of client information, both parties agree to oblige by all other state and federal privacy requirements.
                    </p>

                    {/* Section 6 */}
                    <h3 className="text-lg font-semibold mt-8 mb-3">6. Governing Law</h3>
                    <p>
                        These Terms shall be governed by and construed in accordance with the internal laws of the State of Florida, without giving effect to any choice or conflict of law provision or rule (whether of the State of Florida or any other jurisdiction) that would cause the application of laws of any jurisdiction other than those of the State of Florida.
                    </p>

                    {/* Section 7 */}
                    <h3 className="text-lg font-semibold mt-8 mb-3">7. Indemnification</h3>
                    <p>
                        Both parties agree to mutually indemnify and hold the other party harmless against all claims, reasonable attorney's fees, liabilities, costs, damages, settlements, or expenses that result from the breach of this MOU, and/or from the willful acts or omissions of either party, its agents, or employees in the performance of any of the services or duties pursuant to or related in any way to this MOU. Any and all obligations under this paragraph shall survive the termination of this MOU.
                    </p>

                    {/* Section 8 */}
                    <h3 className="text-lg font-semibold mt-8 mb-3">8. Reference</h3>
                    <p>
                        References to "partner" or "member" does not indicate a membership or partnership agreement between the parties under applicable law. These references are terms of art for convenience.
                    </p>

                    {/* Section 9 */}
                    <h3 className="text-lg font-semibold mt-8 mb-3">9. Counterparts</h3>
                    <p>
                        These Terms may be executed in counterparts, each of which shall be deemed one and the same instrument. By checking the agreement box on the membership application form and submitting your application, you acknowledge that you have read, understood, and agree to be bound by these Terms & Conditions on behalf of your organization.
                    </p>

                    {/* Acceptance Notice */}
                    <div className="bg-muted/50 rounded-lg p-6 mt-8">
                        <p className="text-sm text-muted-foreground mb-0">
                            By checking the agreement box on the membership application form and submitting your application, you acknowledge that you have read, understood, and agree to be bound by these Terms & Conditions on behalf of your organization.
                        </p>
                    </div>
                </CardContent>
            </Card>

            {/* Back to application button */}
            <div className="mt-8 text-center">
                <Link to="/apply">
                    <Button size="lg" data-testid="back-to-apply-btn">
                        Return to Membership Application
                    </Button>
                </Link>
            </div>
        </div>
    );
};

export default TermsConditionsPage;
